/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../common";
import type { RewardTracker, RewardTrackerInterface } from "../RewardTracker";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Claim",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "BASIS_POINTS_DIVISOR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PRECISION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "allowances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "averageStakedAmounts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "balances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "claim",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "claimForAccount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "claimable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "claimableReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "cumulativeRewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "cumulativeRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "depositBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "distributor",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gov",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inPrivateClaimingMode",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inPrivateStakingMode",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "inPrivateTransferMode",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_depositTokens",
        type: "address[]",
      },
      {
        internalType: "address",
        name: "_distributor",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isDepositToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isHandler",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isInitialized",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "previousCumulatedRewardPerToken",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "rewardToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_depositToken",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isDepositToken",
        type: "bool",
      },
    ],
    name: "setDepositToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_gov",
        type: "address",
      },
    ],
    name: "setGov",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_handler",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isActive",
        type: "bool",
      },
    ],
    name: "setHandler",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_inPrivateClaimingMode",
        type: "bool",
      },
    ],
    name: "setInPrivateClaimingMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_inPrivateStakingMode",
        type: "bool",
      },
    ],
    name: "setInPrivateStakingMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_inPrivateTransferMode",
        type: "bool",
      },
    ],
    name: "setInPrivateTransferMode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_depositToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_fundingAccount",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_depositToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "stakeForAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stakedAmounts",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokensPerInterval",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "totalDepositSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "_recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_depositToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "unstake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "address",
        name: "_depositToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_receiver",
        type: "address",
      },
    ],
    name: "unstakeForAccount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "withdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type RewardTrackerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RewardTrackerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class RewardTracker__factory extends ContractFactory {
  constructor(...args: RewardTrackerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _name: string,
    _symbol: string,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(_name, _symbol, overrides || {});
  }
  override deploy(
    _name: string,
    _symbol: string,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(_name, _symbol, overrides || {}) as Promise<
      RewardTracker & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): RewardTracker__factory {
    return super.connect(runner) as RewardTracker__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RewardTrackerInterface {
    return new Interface(_abi) as RewardTrackerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): RewardTracker {
    return new Contract(address, _abi, runner) as unknown as RewardTracker;
  }
}
